import Heading from "@tiptap/extension-heading";

export const CHeading = Heading.extend({
  addAttributes() {
    return {
      id: {
        default: null, // change this if you want a different default value
        //
        parseHTML: (element) => {
          // Get the attribute value from markup if it's available, otherwise assign null as the attribute value
          return element.hasAttribute("id") ? element.getAttribute("id") : null;
        },
      },
    };
  },
});